import React from 'react'
import { FreeResponseGrader } from '../free-response-grader'
import type { GradingResult, QuestionScore } from '../types'
import type { FreeResponseAttemptAnswers } from '@sphere/learning/domain'
import styles from './ActivityGrader.module.scss'

interface ActivityGraderProps {
  activityType?: string
  content: any
  userAnswers: any
  onGrade: (result: GradingResult) => void
  isSubmitting: boolean
  initialScores?: QuestionScore[]
}

export const ActivityGrader: React.FC<ActivityGraderProps> = ({
  activityType,
  content,
  userAnswers,
  onGrade,
  isSubmitting,
  initialScores,
}) => {
  switch (activityType) {
    case 'FREE_RESPONSE':
      return (
        <FreeResponseGrader
          content={content}
          userAnswers={userAnswers as FreeResponseAttemptAnswers}
          onGrade={onGrade}
          isSubmitting={isSubmitting}
          initialScores={initialScores}
        />
      )
    // Future activity types can be added here
    // case 'ESSAY':
    // case 'SHORT_ANSWER':
    default:
      return (
        <div className={styles.unsupportedType}>
          <h3 className={styles.unsupportedTitle}>
            Notation non disponible pour ce type d'activité
          </h3>
          <p className={styles.unsupportedDescription}>
            Le type "{activityType}" ne supporte pas encore la notation
            manuelle.
          </p>
        </div>
      )
  }
}
